import React from "react";
import { MyAppGlobalProbider } from "../../Context";
import { ProjectData } from "./ProjectData.js/ProjectData";

export const FilterProject = () => {
  const { type, HandleInputs } = MyAppGlobalProbider();
  const categoriesAll = [
    "All",
    ...new Set(ProjectData.map((Singleproject) => Singleproject.category)),
  ];
  //   console.log(categoriesAll);
  return (
    <div className="form-project-center">
      <form className="project-fil-form">
        <div className="label-select-project">
          <label htmlFor="select">Choose Projects</label>
        </div>
        <select
          name="type"
          id="type"
          onChange={HandleInputs}
          value={type}
          className="classic"
        >
          {categoriesAll.map((category, index) => {
            return (
              <option value={category} key={index} className="option">
                {category}
              </option>
            );
          })}
        </select>
      </form>
    </div>
  );
};
